<template>
  <div id="gooimeer">
    <b-container class="calculator">
      <b-row class="mt-3 mb-5">
          <b-col class="text-right"><img width="50%" src="./assets/HoeschLogo.png" alt="Logo Hoesch" title="Logo Hoesch"></b-col>
      </b-row>
    </b-container>
    <Calculator layout="hoesch" :languages="languages" />
  </div>
</template>

<script>
  export default{
    props : ['languages'],
    components: {

    },
    name: 'Gooimeer',
    data(){
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style>
  .calculator{
    max-width: 768px;
  }

  .card-header .btn{
    text-align: left;
  }
  .card-header span{
    float: right;
  }

  .spccButton{
    border: 1px solid #f19331;
    background: #f19331;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 1px 0 #444444;
    background-image: -webkit-gradient(linear, left top, left bottom, from( #FFa135), to( #d8842c));
    background-image: -webkit-linear-gradient( #FFa135, #d8842c);
    background-image: -moz-linear-gradient( #FFa135, #d8842c);
    background-image: -ms-linear-gradient( #FFa135, #d8842c);
    background-image: -o-linear-gradient( #FFa135, #d8842c);
    background-image: linear-gradient( #FFa135, #d8842c);
  }

  .initialColor{
    background-image: -webkit-linear-gradient(top,#f5f5f5 0,#e8e8e8 100%);
    background-image: linear-gradient(to bottom,#f5f5f5 0,#e8e8e8 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff5f5f5',endColorstr='#ffe8e8e8',GradientType=0);
    color: #333;
    border: 0px solid #ddd;
  }

  .initialColor:hover{
    color: #333;
  }

  .list, .card{
    width: 100%;
    min-width: 100%;
  }

  h1,h2,h3{
    color: #333;
    width: 100%;
  }
  .resultTable th:first-child, .resultTable td:first-child{
    padding-right: 5px;
    width: 300px;
  }
  .resultTable th:nth-child(2), .resultTable td:nth-child(2), .resultTable th:nth-child(3), .resultTable td:nth-child(3){
    text-align: right;
  }
  .invalid{
    border: red 2px solid;
  }
  .invalidSmall{
    border-left: red 2px solid;
  }

  .loading{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: #FFF;
  }

  .loading .row {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: #FFF;
  }

  .loadingText{
    z-index: 999999999;
    font-size: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/Hoesch.vue